export default __webpack_public_path__ + "images/KN.ff51fde.png";